
  import LayoutDefault from './layouts/layoutDefault'
  export default {
    components: { LayoutDefault }
  }
